(function () {
  "use strict";
  const root = window.Shopify?.routes?.root || "/";
  let cartBusy = false;
  const selected = form => Array.from(form.querySelectorAll("[data-addon-id]:checked"));
  async function request(path, body) {
    const response = await fetch(root + path, body ? {
      method: "POST", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body)
    } : { cache: "no-store" });
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || "カートを更新できませんでした。");
    return data;
  }
  function buildItems(variantId, quantity, choices, group, title) {
    if (!Number.isInteger(quantity) || quantity < 1 || quantity > 99) throw new Error("数量は1〜99で入力してください。");
    const parent = { id: variantId, quantity };
    if (!choices.length) return [parent];
    parent.properties = { _3206_group: group, _3206_role: "parent", "追加オプション": choices.map(choice => choice.name).join(" / ") };
    return [parent, ...choices.map(choice => ({
      id: choice.id, quantity,
      properties: { _3206_group: group, _3206_role: "addon", "対象商品": title }
    }))];
  }
  // Every add receives its own group, so orders with and without extras stay separate.
  async function add(form, variantId, quantity) {
    if (form.dataset.addonBusy === "true") return;
    const buttons = Array.from(form.querySelectorAll('button[type="submit"]'));
    form.dataset.addonBusy = "true";
    const states = buttons.map(button => button.disabled);
    buttons.forEach(button => { button.disabled = true; });
    try {
      const choices = selected(form).map(input => ({ id: Number(input.dataset.addonId), name: input.dataset.addonName, handle: input.dataset.addonHandle }));
      // Validate live catalog data before charging; never silently drop an unavailable option.
      for (const choice of choices) {
        const product = await request(`products/${encodeURIComponent(choice.handle)}.js`);
        const variant = product.variants.find(item => item.id === choice.id);
        if (!variant?.available || variant.price !== 30000) throw new Error(`${choice.name}は現在ご利用いただけません。`);
      }
      const group = window.crypto.randomUUID();
      const title = form.id === "productForm"
        ? `ハーフ&ハーフ (${document.getElementById("productSelect1").value} / ${document.getElementById("productSelect2").value})`
        : document.querySelector("main h2")?.textContent.trim() || "サンドイッチ";
      await request("cart/add.js", { items: buildItems(variantId, quantity, choices, group, title) });
      window.location.assign(root + "cart");
    } catch (error) {
      alert(error.message || "カートに追加できませんでした。");
    } finally {
      delete form.dataset.addonBusy;
      buttons.forEach((button, index) => { button.disabled = states[index]; });
    }
  }
  function groupUpdates(items, key, quantity) {
    const parent = items.find(item => item.key === key);
    if (!parent || parent.properties?._3206_role !== "parent") throw new Error("カートを再読み込みしてください。");
    const updates = {};
    for (const item of items) {
      if (item.properties?._3206_group === parent.properties._3206_group) updates[item.key] = quantity;
    }
    return updates;
  }
  async function changeGroup(element, delta) {
    if (cartBusy) return;
    cartBusy = true;
    const checkout = document.getElementById("checkout-button");
    if (checkout) checkout.setAttribute("aria-disabled", "true");
    try {
      const cart = await request("cart.js");
      const key = element.dataset.itemKey;
      const parent = cart.items.find(item => item.key === key);
      if (!parent) throw new Error("カートを再読み込みしてください。");
      const quantity = delta === null ? 0 : Math.max(0, Math.min(99, parent.quantity + delta));
      await request("cart/update.js", { updates: groupUpdates(cart.items, key, quantity) });
      // Server-rendered totals and quantities avoid stale optimistic cart values.
      window.location.reload();
    } catch (error) {
      alert(error.message || "カートを更新できませんでした。");
      cartBusy = false;
      if (checkout) checkout.removeAttribute("aria-disabled");
    }
  }
  window.Addons3206 = { add, buildItems, groupUpdates, hasSelection: form => selected(form).length > 0 };
  document.addEventListener("submit", event => {
    const form = event.target.closest("[data-standard-product-form]");
    if (!form || !selected(form).length) return;
    event.preventDefault();
    const data = new FormData(form);
    add(form, Number(data.get("id")), Number(data.get("quantity")));
  });
  document.addEventListener("DOMContentLoaded", () => {
    const originalIncrease = window.increaseQuantity;
    const originalDecrease = window.decreaseQuantity;
    window.increaseQuantity = element => {
      const role = element.closest(".cart-item")?.dataset.addonRole;
      if (role === "addon") return;
      if (role === "parent") return changeGroup(element, 1);
      if (!cartBusy) originalIncrease(element);
    };
    window.decreaseQuantity = element => {
      const role = element.closest(".cart-item")?.dataset.addonRole;
      if (role === "addon") return;
      if (role === "parent") return changeGroup(element, -1);
      if (!cartBusy) originalDecrease(element);
    };
    document.querySelectorAll('[data-addon-role="addon"]').forEach(row => {
      row.querySelectorAll(".remove-item, [onclick]").forEach(control => {
        control.style.display = "none";
      });
    });
    document.querySelectorAll("[data-addon-options]").forEach(fieldset => {
      const form = fieldset.closest("form");
      const update = () => {
        const quantity = Number(form.querySelector('[name="quantity"]')?.value || 1);
        const total = selected(form).length * 300 * quantity;
        fieldset.querySelector("[data-addon-total]").textContent = total ? `追加料金：${total.toLocaleString("ja-JP")}円（${quantity}点分）` : "";
      };
      form.addEventListener("change", update);
      form.addEventListener("input", update);
      update();
    });
  });
  // Intercept before the theme's existing remove and checkout listeners.
  document.addEventListener("click", event => {
    if (event.target.closest("#checkout-button") && cartBusy) {
      event.preventDefault(); event.stopImmediatePropagation(); return;
    }
    const remove = event.target.closest(".remove-item");
    if (!remove) return;
    const role = remove.closest(".cart-item")?.dataset.addonRole;
    if (role !== "parent" && role !== "addon") return;
    event.preventDefault(); event.stopImmediatePropagation();
    if (role === "parent") changeGroup(remove, null);
  }, true);
})();
